module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.154ec2b.woff2";